export * from "fp-ts/lib/ReadonlyNonEmptyArray";

import * as RA from "fp-ts/lib/ReadonlyArray";
import type * as RNEA from "fp-ts/lib/ReadonlyNonEmptyArray";

import type { IntRangeExcl } from "./Array";
import { firstN as arrayFirstN } from "./Array";
import { fromNonEmptyRecord as fromNEA } from "./NonEmptyArray";
import type { NonEmptyRecord } from "./Record";


type ExtraReadonlyNonEmptyArrayFields<A> = Omit<RNEA.ReadonlyNonEmptyArray<A>, number | "length">;

export type ReadonlyNonEmptyArrayMaxN<A, N extends number> = { 0: A } & { [i in IntRangeExcl<1, N>]?: A } & {
  length: IntRangeExcl<1, N> | N;
} & ExtraReadonlyNonEmptyArrayFields<A>;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const firstN = arrayFirstN as unknown as <N extends number>(n: N) => <A>(arr: RNEA.ReadonlyNonEmptyArray<A>) => ReadonlyNonEmptyArrayMaxN<A, N>;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const firstNRaw = arrayFirstN as unknown as (n: number) => <A>(arr: RNEA.ReadonlyNonEmptyArray<A>) => RNEA.ReadonlyNonEmptyArray<A>;

export const fromNativeReadonlyNonEmptyArray = <A>(a: readonly [A, ...A[]]): RNEA.ReadonlyNonEmptyArray<A> => {
  const [head, ...tail] = a;
  return RA.prepend(head)(tail);
};

export const fromNonEmptyRecord = <A, K extends keyof A = keyof A>(r: NonEmptyRecord<A, K>): RNEA.ReadonlyNonEmptyArray<A[K]> => fromNEA(r);
